module.exports = __webpack_public_path__ + "static/img/title-es.87834b7c.png";